import ClaimsInsightsDashboardContextProvider, { ClaimsInsightsDashboardContext } from "@app/projects/network-assessment/pci-dashboard/claims-insights/ClaimsInsightsDashboardContext";
import { ClaimsInsightsDashboardDefaultView } from "@app/projects/network-assessment/pci-dashboard/claims-insights/ClaimsInsightsDashboardDefaultView";
import { ClaimsInsightsDashboardScenarioView } from "@app/projects/network-assessment/pci-dashboard/claims-insights/ClaimsInsightsDashboardScenarioView";
import PciDashboardFilters from "@app/projects/network-assessment/pci-dashboard/shared/PciDashboardFilters";
import PciDashboardFiltersContextProvider, { PciDashboardFiltersContext } from "@app/projects/network-assessment/pci-dashboard/shared/PciDashboardFiltersContext";
import PciDashboardWrapper from "@app/projects/network-assessment/pci-dashboard/shared/PciDashboardWrapper";
import React, { FC, useContext } from "react";

const WrappedClaimsInsightsDashboard: React.FC<React.PropsWithChildren<unknown>> = () => {
  const claimsInsightsContext = useContext(ClaimsInsightsDashboardContext);
  const pciDashboardFiltersContext = useContext(PciDashboardFiltersContext);

  return (
    <PciDashboardWrapper>
      <PciDashboardFilters
        isLoading={
          claimsInsightsContext.marketProvidersEffectivenessLoading ||
          claimsInsightsContext.marketProvidersEfficiencyLoading ||
          claimsInsightsContext.networkProvidersEffectivenessLoading ||
          claimsInsightsContext.networkProvidersEfficiencyLoading ||
          claimsInsightsContext.prospectProvidersEffectivenessLoading ||
          claimsInsightsContext.prospectProvidersEfficiencyLoading ||
          claimsInsightsContext.countySummariesLoading ||
          claimsInsightsContext.specialtySummariesLoading
        }
        isPca={false}
        onApplyFiltersClick={claimsInsightsContext.onApplyFiltersClick}
        showLineOfBusiness={false}
      />
      {pciDashboardFiltersContext?.displayedFilters?.compareTimeslices ? (
        <ClaimsInsightsDashboardScenarioView />
      ) : (
        !claimsInsightsContext.showDashboardDetails && <ClaimsInsightsDashboardDefaultView />
      )}
    </PciDashboardWrapper>
  );
}

const ClaimsInsightsDashboard: FC = () => (
  <PciDashboardFiltersContextProvider>
    <ClaimsInsightsDashboardContextProvider>
      <WrappedClaimsInsightsDashboard />
    </ClaimsInsightsDashboardContextProvider>
  </PciDashboardFiltersContextProvider>
);

export default ClaimsInsightsDashboard;
